
import * as React from 'react';
import styled from 'styled-components';
import * as Highcharts from 'highcharts';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { HighChart } from '@process-advisor/process-miner/components/charts/highChart/highChart';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

let optionsAttributes = [];

export const TaskAttributes: React.FC = () => {
    const [data, setData] = React.useState([]);
    const [title, setTitle] = React.useState(apiProvider.getEntityUpper() +'s by Volume');
    const [chartTypeStr, setChartTypeStr] = React.useState('bar');
    const [metric, setMetric] = React.useState(1);
    const [attribute, setAttribute] = React.useState('');
    const [chartType, setChartType] = React.useState(1);


    let optionsMetrics = [
            { value: 1, label: 'Volume' },
            { value: 2, label: 'Avg Duration (mins)' },
            { value: 3, label: 'Avg Duration (hrs)' },
            { value: 4, label: 'Avg Duration (days)' },
            { value: 13, label: 'Worklogs'},
            { value: 14, label: 'Avg TimeSpent (mins)'},
            { value: 15, label: 'Total Time Spent (mins)'},
        ];
    
    const chartTypeOptions = [
        { value: 1, label: 'Bar' },
        { value: 2, label: 'Column' },
    ];

    React.useEffect(() => {
        setChartTypeStr('bar')         
        setChartType(1)
        setMetric(1)
       
        taskAttributes();
        const temp = apiProvider.getAnalyticsTaskAttribute()
        if (temp['attribute'] != '') {
            setAttribute(temp['attribute'])
        }
        setTitle(apiProvider.getEntityUpper() +'s by ' + attribute + ' (' + optionsMetrics.find(option => option.value === metric)?.label || 'Volume' + ')')
    }, []);


    const onAttributeChange = (attributeSelected: string) => {
        setAttribute(attributeSelected)
        apiProvider.changeAnalyticsTaskAttribute({ attribute : attributeSelected});
        setData(apiProvider.analyticsTaskAttributes());
        setTitle(apiProvider.getEntityUpper() + 's by ' + attributeSelected + ' (' + optionsMetrics.find(option => option.value === metric)?.label || 'Volume' + ')')
    };

    const onMetricChange = (metricSelected: number) => {
        setMetric(metricSelected);
        apiProvider.changeAnalyticsTaskAttributeMetric({ metric : metricSelected });
        setData(apiProvider.analyticsTaskAttributes());
        setTitle(apiProvider.getEntityUpper() + 's by ' + attribute + ' (' + optionsMetrics.find(option => option.value === metricSelected)?.label || 'Volume' + ')')
    };

    const onChartTypeChange = (chartTypeSelected: number) => {
        setChartType(chartTypeSelected)
        if (chartTypeSelected == 1) { setChartTypeStr('bar'); }
        if (chartTypeSelected == 2) { setChartTypeStr('column')}
    };

    const taskAttributes = () => {
        optionsAttributes = [];
        const tOptions = apiProvider.taskAttributes({});
        for (const each of tOptions) {
            const valueToPush = { value: each.value, label: each.label };
            optionsAttributes.push(valueToPush);
        }
        if (optionsAttributes.length > 0 ) {
            setAttribute(optionsAttributes[0].value);
        }
    };

    useApiListener(
        Event.updateTaskAttributes,
        () => taskAttributes()
    );

    React.useEffect(() => {
        const listener = () => {
            setData(apiProvider.analyticsTaskAttributes());
        }
        listener();
        apiProvider.on(Event.updateTasks, listener);
        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.updateTasks, listener);
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    const barColumnOptions: Highcharts.Options = {
        chart: {
            //           renderTo: 'container',
            type: chartTypeStr,
            style: {
                fontFamily: 'system-ui'

            },
            borderWidth: 2,
            borderColor: '#E0E0E0',
//            backgroundColor: "#EBF1FB"
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
        xAxis: {
            type: 'category',
            title: {
                text: null,
            },
            min: 0,
            max: Math.min(data.length - 1, 20),
            scrollbar: {
                enabled: true,
            },
            tickLength: 0,
        },
        tooltip: {
            formatter () {
                if (metric == 1) {
                    return Highcharts.numberFormat(this.y, null, null, ',');
                } 
                if (metric == 2 || metric == 3 || metric == 4 || metric == 11|| metric == 12 || metric == 13 || metric == 14 || metric == 15) {
                    return Number(this.y.toFixed(1)).toLocaleString()
                }
                if (metric == 5 || metric == 6 || metric == 7 || metric == 8 || metric == 9 || metric == 10 ) {
                    return '$' + Number(this.y.toFixed(2)).toLocaleString()
                }
            },
        },
        yAxis: {
            title: {
                text: '',
            },
        },
        legend: {
            enabled: true,
        },
        plotOptions: {
            series: {
                shadow: true,
                dataLabels: {
                    enabled: true,
                    formatter () {
                        if (metric == 1) {
                            return Highcharts.numberFormat(this.y, null, null, ',');
                        } 
                        if (metric == 2 || metric == 3 || metric == 4) {
                            return Number(this.y.toFixed(1)).toLocaleString()
                        }
                        if (metric == 5 ) {
                            return this.y.toFixed(1) +'%'
                        }
                        if (metric == 6 || metric == 7 || metric == 8 || metric == 9 || metric == 10 || metric == 11 ) {
                            return '$' + Number(this.y.toFixed(2)).toLocaleString()
                        }
                    },
                    style: {
                        fontWeight: 'normal',
                    },
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                type: 'column',
                color: '#0B66E4',
                dataSorting: {
                    enabled: true,
                    sortKey: 'y',
                },
                data: data,
                name: 'Task',
            },
        ],
    };
    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Group by:'/>
            </SingleBlock>
            <SingleBlock width="20%">
                <Dropdown
                    options={optionsAttributes}
                    onChange={onAttributeChange}
                    value={attribute}/>
            </SingleBlock>
            <SingleBlock width="10%">
                <Section title='Metric:'/>
            </SingleBlock>
            <SingleBlock width="20%">
                <Dropdown
                    options={optionsMetrics}
                    onChange={onMetricChange}
                    value={metric}/>
            </SingleBlock>
            <SingleBlock width="10%">
                <Section title='Chart Type:'/>
            </SingleBlock>
            <SingleBlock width="30%">
                <Dropdown
                    options={chartTypeOptions}
                    onChange={onChartTypeChange}
                    value={chartType}/>
            </SingleBlock>
            <HighChart options={barColumnOptions} />
        </Wrapper>
    );
};
